import { useEffect, useState } from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useDispatch, useSelector } from 'react-redux';
import { updateFilter, showFilter } from '../../../../../../store/actions/filter.actions';
import { useLocation, useNavigate } from 'react-router-dom';
import isEmpty from 'lodash/isEmpty';
import InputField from '../../../../../FormControl/input/InputField';
import SelectMultipleField from '../../../../../FormControl/input/SelectMultipleField';
import { updateSkip } from '../../../../../../store/actions/datatable.actions';
import DialogConfirmCancel from '../../../../../dialog/DialogConfirm';
import AutocompleteField from '../../../../../FormControl/input/AutocompleteField';

const FilterDialog = ({
  isLoadingClasses,
  dataClasses,
  isLoadingYears,
  dataYears,
  errorFetchYears,
  showFilters
}) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const filter = useSelector((state) => state?.filter.assessmentMarking?.filter || {});
  const open = useSelector((state) => state?.filter.assessmentMarking?.open || false);

  const dispatch = useDispatch();

  const [form, setInputForm] = useState(filter);
  const [error, setInputError] = useState({});

  useEffect(() => {
    if (!isEmpty(filter)) {
      setInputForm(filter);
    }
  }, [filter]);

  const onClose = () => {
    dispatch(showFilter('assessmentMarking', false));
  };

  const onChange = (name, value) => {
    if (name === 'classes') {
      setInputError({ ...error, [name]: null, classes: null });
      const ids = value.map((item) => item.label);
      setInputForm({ ...form, [name]: value, classesCode: ids });
    } else if (name === 'yearLevelId') {
      setInputError({ ...error, [name]: null, yearLevel: null });
      const yearLevel = dataYears.filter((item) => value.includes(item._id));
      setInputForm({ ...form, [name]: value, yearLevel });
    } else {
      setInputForm({ ...form, [name]: value });
      setInputError({ ...error, [name]: null });
    }
  };

  const onApply = () => {
    onClose();
    const filter = {
      ...form
    };

    dispatch(updateFilter('assessmentMarking', filter));
    dispatch(updateSkip('assessmentMarking', 0));
    navigate(pathname, { state: filter });
  };

  return (
    <DialogConfirmCancel
      id='user-filter'
      open={open}
      title='Filter'
      maxWidth='xs'
      onCancel={onClose}
      onConfirm={onApply}
      textConfirm='Apply'
    >
      <Box className='flex flex-col gap-4'>
        <div className='grid grid-cols-3 items-center gap-4'>
          <Typography
            variant='inherit'
            className='font-bold capitalize'
            color='primary'
            align='right'
            component='p'
          >
            Code
          </Typography>
          <div className='col-span-2'>
            <InputField
              id='form-filter-code'
              name='student-code'
              value={form.studentCode}
              error={error.studentCode}
              helperText={error.studentCode}
              onChange={(e) => onChange('studentCode', e.target.value)}
            />
          </div>
          <Typography
            variant='inherit'
            className='font-bold capitalize'
            color='primary'
            align='right'
            component='p'
          >
            First name
          </Typography>
          <div className='col-span-2'>
            <InputField
              id='form-filter-first-name'
              name='student-first-name'
              value={form.studentFirstName}
              error={error.studentFirstName}
              helperText={error.studentFirstName}
              onChange={(e) => onChange('studentFirstName', e.target.value)}
            />
          </div>
          <Typography
            variant='inherit'
            className='font-bold capitalize'
            color='primary'
            align='right'
            component='p'
          >
            Last name
          </Typography>
          <div className='col-span-2'>
            <InputField
              id='form-filter-last-name'
              name='student-last-name'
              value={form.studentLastName}
              error={error.studentLastName}
              helperText={error.studentLastName}
              onChange={(e) => onChange('studentLastName', e.target.value)}
            />
          </div>
          <Typography
            variant='inherit'
            className='font-bold capitalize'
            color='primary'
            align='right'
            component='p'
          >
            Form
          </Typography>
          <div className='col-span-2'>
            <InputField
              id='form-filter-form'
              name='student-form'
              value={form.studentForm}
              error={error.studentForm}
              helperText={error.studentForm}
              onChange={(e) => onChange('studentForm', e.target.value)}
            />
          </div>
          {showFilters?.classes && (
            <>
              <Typography
                variant='inherit'
                className='font-bold capitalize'
                color='primary'
                align='right'
                component='p'
              >
                Classes
              </Typography>
              <div className='col-span-2'>
                <AutocompleteField
                  id='form-filter-classes'
                  name='classes'
                  placeholder='Choose a class'
                  options={
                    dataClasses.map((item) => ({
                      value: item._id,
                      label: item.code
                    })) || []
                  }
                  multiple={true}
                  onChange={(value) => onChange('classes', value)}
                  loading={isLoadingClasses}
                  value={form.classes || []}
                />
              </div>
            </>
          )}
          {showFilters?.yearLevel && (
            <>
              <Typography
                variant='inherit'
                className='font-bold capitalize'
                color='primary'
                align='right'
                component='p'
              >
                year level
              </Typography>
              <div className='col-span-2'>
                <SelectMultipleField
                  id='form-filter-year-level'
                  name='yearLevelId'
                  value={form.yearLevelId}
                  error={error.yearLevelId || errorFetchYears}
                  helperText={error.yearLevelId || errorFetchYears}
                  onChange={(e) => onChange('yearLevelId', e.target.value)}
                  loading={isLoadingYears}
                  options={dataYears?.map((item) => ({ value: item._id, label: item.name })) || []}
                  placeholder='Choose a year level'
                />
              </div>
            </>
          )}
        </div>
      </Box>
    </DialogConfirmCancel>
  );
};

export default FilterDialog;
